<template>
    <div>
        <template v-if="totalSteps">

            <table cellpadding="0" cellspacing="0" border="0" style="background-color: #eee; width: 100%; font-size: 14px; font-weight: 600">
                <tr>
                    <td style="text-align: left; padding: 10px; font-weight: 600">
                        {{ $t('plan_calculator.' + jaw) }}
                    </td>
                    <td style="text-align: right; padding: 10px;">
                        <pm-price style="font-size: 12px; font-weight: 600;" :currency="$store.state.currency" :value="$store.state.simplePlan[jaw + 'JawTotal']" />
                    </td>
                </tr>
            </table>

            <table cellpadding="0" cellspacing="0" border="0" style="width: 100%; font-size: 14px; font-weight: 600">
                <tr>
                    <td colspan="2" style="text-align: left; padding: 10px; font-size: 12px; font-weight: 600">
                       {{ title }}
                    </td>
                </tr>
                <tr v-for="(option, key) in options" v-if="option!==null" >
                    <td style="border-top: 1px dotted #eee; font-size: 12px; text-align: left; padding: 10px; font-weight: 600">
                        <span v-if="['full_jaw_6_12', 'full_jaw_6_14', 'full_jaw_8_12', 'full_jaw_8_14'].includes(option.tpl)">
                            {{ getOptionTitle(option) }}
                        </span>
                        <span v-else>{{ option.amount }} {{ $t('plan_calculator.state_' + key) }}: {{ getOptionTitle(option) }}</span>
                    </td>
                    <td style="border-top: 1px dotted #eee; font-size: 12px; text-align: right; padding: 10px;">
                        <pm-price style="font-size: 12px; color: #444;" :value="option.price" />
                    </td>
                </tr>
            </table>
        </template>
    </div>
</template>

<script>
import PmTreatmentOverview from "./treatment-overview";

export default {
    extends: PmTreatmentOverview,
};
</script>
